import { ActionCreatorFactory } from "typescript-fsa";

export const createAsyncAction = <Req, Res>(createAction: ActionCreatorFactory, actionName = "FETCH_ASYNC") => {
  return createAction.async<Req, Res, string>(actionName);
};
